/**
 * Marka adı: üstte küçük "Adım Adım" (iki kelime ayrı renkte), altında büyük
 * "Terakki". tone="light" açık zeminde (turuncu, mavi, tema turkuazı);
 * tone="dark" turkuaz ya da koyu zeminde okunur tonlar (açık turuncu, açık
 * mavi, beyaz). size: "sm" üst menü ve alt bilgi, "lg" giriş sayfaları.
 */
const TONES = {
  light: { first: "text-[#E8862E]", second: "text-[#2F7FD8]", main: "text-terakkiPrimaryDark" },
  dark: { first: "text-[#FFB45C]", second: "text-[#A9D6FF]", main: "text-white" },
};

const SIZES = {
  xs: { top: "text-[10px] tracking-[0.18em]", main: "text-base font-SemiBold", gap: "mt-0.5" },
  sm: { top: "text-[11px] tracking-[0.18em]", main: "text-2xl font-Bold tracking-wide", gap: "mt-0.5" },
  lg: { top: "text-sm md:text-base tracking-[0.32em]", main: "text-5xl md:text-6xl font-extrabold tracking-wide", gap: "mt-1" },
};

export default function BrandLockup({ tone = "light", size = "sm", className = "" }) {
  const c = TONES[tone];
  const s = SIZES[size];
  return (
    <span className={`flex flex-col leading-none ${className}`}>
      <span className={`font-Bold uppercase ${s.top}`}>
        <span className={c.first}>Adım</span> <span className={c.second}>Adım</span>
      </span>
      <span className={`${s.gap} ${s.main} ${c.main}`}>Terakki</span>
    </span>
  );
}
